import { BollardPosition as ServerBollardPosition } from 'server/models/BollardPosition';
import { PierMark } from './PierMark';

export * from 'server/models/BollardPosition';

export class BollardPosition extends ServerBollardPosition {
    static PierMarkOrder(bol1 : BollardPosition, bol2 : BollardPosition) {
        const
            bol1PierMark = bol1.PierMark,
            bol2PierMark = bol2.PierMark.convert(bol1PierMark.UOM()),
            cmp = bol1PierMark.Num() - bol2PierMark.Num();
        return cmp === 0 ? bol1.Id() - bol2.Id() : cmp;
    }

    get PierMark() {
        return new PierMark(this.Footmark, this.Berth);
    }
}



// WEBPACK FOOTER //
// ./data/models/BollardPosition.ts